import script from "./cLanguage.vue?vue&type=script&setup=true&lang=js"
export * from "./cLanguage.vue?vue&type=script&setup=true&lang=js"

import "./cLanguage.vue?vue&type=style&index=0&id=a59e4bd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a59e4bd4"]])

export default __exports__